import { useCallback, useEffect, useRef } from 'react';
import { noop } from 'lodash';

const DEFAULT_CHECK_TIMEOUT = 100;
const DEFAULT_FREEZE_TOLERANCE_TIMEOUT = 5000;

export const useOnBrowserUnfreezed = ({
    callback = noop,
    checkTimeout = DEFAULT_CHECK_TIMEOUT,
    freezeToleranceTimeout = DEFAULT_FREEZE_TOLERANCE_TIMEOUT,
} = {}) => {
    const timestampRef = useRef(Date.now());
    const hasBeenFreezed = useCallback(
        () => Date.now() - timestampRef.current > checkTimeout + freezeToleranceTimeout,
        [checkTimeout, freezeToleranceTimeout]
    );

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (hasBeenFreezed()) {
                callback();
            }
            timestampRef.current = Date.now();
        }, checkTimeout);

        return () => clearInterval(intervalId);
    }, [callback, checkTimeout, hasBeenFreezed]);

    return hasBeenFreezed;
};
